import script from "./SearchInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchInput.vue?vue&type=script&setup=true&lang=js"

import "./SearchInput.vue?vue&type=style&index=0&id=3ab45e6a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ab45e6a"]])

export default __exports__